module.exports = __webpack_public_path__ + "img/laosdc.b757438e.png";